import { render } from "./ErrorModal.vue?vue&type=template&id=5ee81dca"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"
script.render = render

export default script